/**
 * Automization Slider Module
 * 
 * @package KateMedia
 */

export function initAutomizationSlider() {
    const sliderContainer = document.querySelector('.automization__content-full');
    const contentWrapper = document.querySelector('.automization__content-wrapper');
    const prevBtn = document.querySelector('.automization__nav-btn--prev');
    const nextBtn = document.querySelector('.automization__nav-btn--next');
    
    if (!sliderContainer || !contentWrapper || !prevBtn || !nextBtn) {
        return;
    }

    let currentPosition = 0;
    const slideWidth = window.innerWidth * 0.75;
    let isAnimating = false;

    function smoothScrollTo(targetPosition, duration = 200) {
        if (isAnimating) return;
        
        isAnimating = true;
        const startPosition = currentPosition;
        const distance = targetPosition - startPosition;
        const startTime = performance.now();

        function animate(currentTime) {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            
            currentPosition = startPosition + distance * progress;
            contentWrapper.style.transform = `translateX(-${currentPosition}px)`;
            
            if (progress < 1) {
                requestAnimationFrame(animate);
            } else {
                isAnimating = false;
                updateButtonStates();
            }
        }
        
        requestAnimationFrame(animate);
    }

    function updateButtonStates() {
        const maxScroll = contentWrapper.scrollWidth - sliderContainer.clientWidth;
        
        prevBtn.disabled = currentPosition <= 0;
        nextBtn.disabled = currentPosition >= maxScroll;
        
        if (currentPosition <= 0) {
            prevBtn.classList.add('swiper-button-disabled');
        } else {
            prevBtn.classList.remove('swiper-button-disabled');
        }
        
        if (currentPosition >= maxScroll) {
            nextBtn.classList.add('swiper-button-disabled');
        } else {
            nextBtn.classList.remove('swiper-button-disabled');
        }
    }

    prevBtn.addEventListener('click', () => {
        const targetPosition = Math.max(0, currentPosition - slideWidth);
        smoothScrollTo(targetPosition);
    });

    nextBtn.addEventListener('click', () => {
        const maxScroll = contentWrapper.scrollWidth - sliderContainer.clientWidth;
        const targetPosition = Math.min(maxScroll, currentPosition + slideWidth);
        smoothScrollTo(targetPosition);
    });

    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            const newSlideWidth = window.innerWidth * 0.75;
            if (Math.abs(newSlideWidth - slideWidth) > 50) {
                currentPosition = Math.min(currentPosition, contentWrapper.scrollWidth - sliderContainer.clientWidth);
                contentWrapper.style.transform = `translateX(-${currentPosition}px)`;
                updateButtonStates();
            }
        }, 250);
    });

    updateButtonStates();
    contentWrapper.style.transition = 'transform 0.2s linear';
}
